import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { OperativoRoutingModule } from './operativo-routing.module';
import { MatrizEventosComponent } from './matriz-eventos/matriz-eventos.component';
import { AnalisisEventosComponent } from './analisis-eventos/analisis-eventos.component';
import { AnalisisCombinadoComponent } from './analisis-combinado/analisis-combinado.component';
import { MapaCalorComponent } from './mapa-calor/mapa-calor.component';


@NgModule({
  declarations: [
    MatrizEventosComponent,
    AnalisisEventosComponent,
    AnalisisCombinadoComponent,
    MapaCalorComponent
  ],
  imports: [
    CommonModule,
    OperativoRoutingModule,
    SharedModule
  ]
})
export class OperativoModule { }
